import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles, Lock } from "lucide-react";
import { auth } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await auth.login(email, password);
      auth.saveSession(data);
      toast.success("¡Bienvenida!");
      nav(data.user.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen flex items-center justify-center rose-grain p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <Sparkles className="text-[var(--brand-primary)]" size={24} />
          <span className="font-heading text-2xl">Valeriia <em className="text-[var(--brand-primary)] not-italic">Nail Academy</em></span>
        </Link>
        <div className="card-luxe p-8">
          <div className="flex items-center gap-2 mb-6">
            <Lock className="text-[var(--brand-primary)]" size={20}/>
            <h1 className="font-heading text-3xl">Acceder al aula</h1>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div>
              <Label htmlFor="password">Contraseña</Label>
              <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <button data-testid="login-submit" className="btn-brand w-full justify-center" disabled={loading}>
              {loading ? "Entrando…" : "Entrar"}
            </button>
          </form>
          <p className="text-xs text-[var(--text-muted)] mt-6 text-center">
            ¿Aún no tienes cuenta? Recibirás las credenciales por email tras la compra en la <Link to="/" className="text-[var(--brand-primary)] underline">página principal</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}
